import Vue from 'vue';

import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

import { faTrashAlt } from '@fortawesome/free-solid-svg-icons/faTrashAlt';

// Import and add more icons here
library.add(faTrashAlt);
 
Vue.component('font-awesome-icon', FontAwesomeIcon);
